import { useMutation } from '@tanstack/react-query'
import { AxiosResponse } from 'axios'

import { loginWithEmailAndPassword } from '@src/api'
import {
  AuthenticationResponse,
  DefaultApiLoginPostRequest,
} from '@src/api/generated/iam'
import { useAxios } from '@src/hooks'

import { LoginError } from './type'

export const useLoginWithEmailAndPassword = () => {
  const { axiosInstance } = useAxios({ apiType: 'IAM', shouldSkipLogout: true })

  return useMutation<
    AxiosResponse<AuthenticationResponse>,
    AxiosResponse<LoginError>,
    DefaultApiLoginPostRequest
  >({
    mutationFn: (params: DefaultApiLoginPostRequest) =>
      loginWithEmailAndPassword(axiosInstance, params),
  })
}
